import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M56 0V32H10.5508L0 16L10.5508 0H56ZM9.58301 16L14.8584 24H48V8H14.8584L9.58301 16Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 32

/**
 * Tag Left cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const TagLeftCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default TagLeftCutoutShape
